module.exports = __webpack_public_path__ + "ecosystem_pro.d27d8e35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/ecosystem_pro.png
// module id = 242
// module chunks = 0